// Apply cursor style to document head by ID
export const applyCursorStyle = (id: string, cursorUrl: string) => {
  removeCursorStyle(id);
  const style = document.createElement("style");
  style.id = id;
  style.textContent = `* { cursor: url(${cursorUrl}), auto !important; }`;
  document.head.appendChild(style);
};

// Remove cursor style element by ID
export const removeCursorStyle = (id: string) => {
  const style = document.getElementById(id);
  if (style) style.remove();
};

// Remove all features like reading mask and guide
export const removeAllFeatures = () => {
  document.body.dataset.cursor = "";

  const elementsToRemove = ["readingMask", "readingGuide", "readingGuideStyle"];
  elementsToRemove.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.remove();
  });
};
